import BaseService from './base_service'

class PageService extends BaseService {
  constructor (options = {}) {
    options.queryParams = options.queryParams || {}
    options.queryParams.path = options.queryParams.path || window.location.pathname
    super(options)
  }

  static fetch (options) {
    const instance = new PageService(options)
    return instance.fetch()
  }

  get serviceName () {
    return 'page'
  }
}

export default PageService
